const skills: string[] = [
  "HTML5",
  "CSS3",
  "Javscript",
  "jQuery",
  "Typescript",
  "Angular",
  "Ionic 5",
  "Android Development",
  "Flask",
  "ROS",
  "Flutter",
  "React",
  "Redux",
  "Laravel",
  "Node.js",
  "Express",
  "Firebase",
  "MySQL",
  "MongoDB",
  "Google Cloud Platform",
  "Amazon Web Services",
  "CloudFlare",
  "Unit Testing",
  "MVC",
  "Git",
  "Fastlane",
  "Responsive Design",
  "MVVM",
  "Docker",
  "Java",
  "Python",
  "VHDL",
];
export default skills;
///Rest apis
//Graphql
//arduino
//Raspberrypi
//socket.io
//BOOSTRAP
